import Model from '../Model'

export default class WithdrawalInternationalWireTransfer extends Model {
  resource() {
    return 'admin/international-wire-transfer/withdrawals'
  }
}
